export interface Bq2CertificationM {
  // Safety Equipment Certificate (SEC)
  secIssued: string | null;
  secLastAnnual: string | null;
  secExpires: string | null;

  // Safety Radio Certificate (SRC)
  srcIssued: string | null;
  srcLastAnnual: string | null;
  srcExpires: string | null;

  // Safety Construction Certificate (SCC)
  sccIssued: string | null;
  sccLastAnnual: string | null;
  sccExpires: string | null;

  // International Loadline Certificate (ILC)
  ilcIssued: string | null;
  ilcLastAnnual: string | null;
  ilcExpires: string | null;

  // ISM Safety Management Certificate (SMC)
  smcIssued: string | null;
  smcLastIntermediate: string | null; // or "smcLastAnnual" if that's how you prefer
  smcExpires: string | null;

  // Document of Compliance (DOC)
  docIssued: string | null;
  docEndorsed: string | null;
  docExpires: string | null;

  // Cargo Gear
  cargoGearIssued: string | null;
  cargoGearLastAnnual: string | null;
  cargoGearExpires: string | null;

  // Cargo Securing Manual
  cargoSecManualIssued: string | null;
  cargoSecManualLastAnnual: string | null;
  cargoSecManualExpires: string | null;

  // International Oil Pollution Prevention Certificate (IOPPC)
  ioppcIssued: string | null;
  ioppcLastAnnual: string | null;
  ioppcExpires: string | null;

  // Ship Sanitation Control (SSCC) / Ship Sanitation Control Exemption (SSCE)
  ssccSsceIssued: string | null;
  ssccSsceExpires: string | null;

  // U.S. Certificate of Financial Responsibility (COFR)
  cofrIssued: string | null;
  cofrExpires: string | null;

  // International Ship Security Certificate (ISSC)
  isscIssued: string | null;
  isscExpires: string | null;

  // Maritime Labour Certificate (MLC)
  mlcIssued: string | null;
  mlcExpires: string | null;

  // Minimum Safe Manning Certificate (MSM)
  msmIssued: string | null;
  msmLastAnnual: string | null;
  msmExpires: string | null;

  // Certificate of Registry (COR)
  corIssued: string | null;
  corExpires: string | null;
  corExpiresNA: boolean;

  // International Tonnage Certificate (ITC)
  itcIssued: string | null;
  itcLastAnnual: string | null;
  itcExpires: string | null;
}

export const initialBq2Certification: Bq2CertificationM = {
  // Safety Equipment Certificate (SEC)
  secIssued: null,
  secLastAnnual: null,
  secExpires: null,

  // Safety Radio Certificate (SRC)
  srcIssued: null,
  srcLastAnnual: null,
  srcExpires: null,

  // Safety Construction Certificate (SCC)
  sccIssued: null,
  sccLastAnnual: null,
  sccExpires: null,

  // International Loadline Certificate (ILC)
  ilcIssued: null,
  ilcLastAnnual: null,
  ilcExpires: null,

  // ISM Safety Management Certificate (SMC)
  smcIssued: null,
  smcLastIntermediate: null, // or "smcLastAnnual" if that's how you prefer
  smcExpires: null,

  // Document of Compliance (DOC)
  docIssued: null,
  docEndorsed: null,
  docExpires: null,

  // Cargo Gear
  cargoGearIssued: null,
  cargoGearLastAnnual: null,
  cargoGearExpires: null,

  // Cargo Securing Manual
  cargoSecManualIssued: null,
  cargoSecManualLastAnnual: null,
  cargoSecManualExpires: null,

  // International Oil Pollution Prevention Certificate (IOPPC)
  ioppcIssued: null,
  ioppcLastAnnual: null,
  ioppcExpires: null,

  // Ship Sanitation Control (SSCC) / Ship Sanitation Control Exemption (SSCE)
  ssccSsceIssued: null,
  ssccSsceExpires: null,

  // U.S. Certificate of Financial Responsibility (COFR)
  cofrIssued: null,
  cofrExpires: null,

  // International Ship Security Certificate (ISSC)
  isscIssued: null,
  isscExpires: null,

  // Maritime Labour Certificate (MLC)
  mlcIssued: null,
  mlcExpires: null,

  // Minimum Safe Manning Certificate (MSM)
  msmIssued: null,
  msmLastAnnual: null,
  msmExpires: null,

  // Certificate of Registry (COR)
  corIssued: null,
  corExpires: null,
  corExpiresNA: false,

  // International Tonnage Certificate (ITC)
  itcIssued: null,
  itcLastAnnual: null,
  itcExpires: null,
};

export function mapSqlToBq2CertificationForm(cert: any): Bq2CertificationM {
  return {
    secIssued: cert?.SEC_ISSUED || null,
    secLastAnnual: cert?.SEC_LAST_ANNUAL || null,
    secExpires: cert?.SEC_EXPIRES || null,
    srcIssued: cert?.SRC_ISSUED || null,
    srcLastAnnual: cert?.SRC_LAST_ANNUAL || null,
    srcExpires: cert?.SRC_EXPIRES || null,
    sccIssued: cert?.SCC_ISSUED || null,
    sccLastAnnual: cert?.SCC_LAST_ANNUAL || null,
    sccExpires: cert?.SCC_EXPIRES || null,
    ilcIssued: cert?.ILC_ISSUED || null,
    ilcLastAnnual: cert?.ILC_LAST_ANNUAL || null,
    ilcExpires: cert?.ILC_EXPIRES || null,
    smcIssued: cert?.SMC_ISSUED || null,
    smcLastIntermediate: cert?.SMC_LAST_INTERMEDIATE || null,
    smcExpires: cert?.SMC_EXPIRES || null,
    docIssued: cert?.DOC_ISSUED || null,
    docEndorsed: cert?.DOC_ENDORSED || null,
    docExpires: cert?.DOC_EXPIRES || null,
    cargoGearIssued: cert?.CARGO_GEAR_ISSUED || null,
    cargoGearLastAnnual: cert?.CARGO_GEAR_LAST_ANNUAL || null,
    cargoGearExpires: cert?.CARGO_GEAR_EXPIRES || null,
    cargoSecManualIssued: cert?.CARGO_SEC_MANUAL_ISSUED || null,
    cargoSecManualLastAnnual: cert?.CARGO_SEC_MANUAL_LAST_ANNUAL || null,
    cargoSecManualExpires: cert?.CARGO_SEC_MANUAL_EXPIRES || null,
    ioppcIssued: cert?.IOPPC_ISSUED || null,
    ioppcLastAnnual: cert?.IOPPC_LAST_ANNUAL || null,
    ioppcExpires: cert?.IOPPC_EXPIRES || null,
    ssccSsceIssued: cert?.SSCC_SSCE_ISSUED || null,
    ssccSsceExpires: cert?.SSCC_SSCE_EXPIRES || null,
    cofrIssued: cert?.COFR_ISSUED || null,
    cofrExpires: cert?.COFR_EXPIRES || null,
    isscIssued: cert?.ISSC_ISSUED || null,
    isscExpires: cert?.ISSC_EXPIRES || null,
    mlcIssued: cert?.MLC_ISSUED || null,
    mlcExpires: cert?.MLC_EXPIRES || null,
    msmIssued: cert?.MSM_ISSUED || null,
    msmLastAnnual: cert?.MSM_LAST_ANNUAL || null,
    msmExpires: cert?.MSM_EXPIRES || null,
    corIssued: cert?.COR_ISSUED || null,
    corExpires: cert?.COR_EXPIRES || null,
    corExpiresNA: cert?.COR_EXPIRES_NA || null,
    itcIssued: cert?.ITC_ISSUED || null,
    itcLastAnnual: cert?.ITC_LAST_ANNUAL || null,
    itcExpires: cert?.ITC_EXPIRES || null,
  };
}
